import React from "react";
import contactData from "../data/contactData.json";
import { useTranslation } from "react-i18next";

const ContactUsCard = () => {
  const { t } = useTranslation("contactuscard");

  return (
    <>
      <hr className="mt-8 mb-8 border-t-2 border-gray-300" />

      <h2 className="text-3xl font-semibold text-center mb-6">
        {t("contactInfoTitle")}
      </h2>

      <div className="flex flex-wrap mx-4">
        {contactData.map((contact, index) => (
          <div key={index} className="w-full md:w-1/3 p-4">
            <div className="bg-gray-100 text-black p-6 rounded-lg shadow-md h-full">
              <h3 className="text-xl font-semibold mb-2">{contact.name}</h3>
              <p className="mb-2">
                <strong>{t("addressLabel")}</strong> {contact.address}
              </p>
              <p className="mb-2">
                <strong>{t("emailLabel")}</strong>{" "}
                <a
                  href={`mailto:${contact.email}`}
                  className="text-blue-600 hover:text-blue-800"
                >
                  {contact.email}
                </a>
              </p>
              <p className="mb-2">
                <strong>{t("phoneLabel")}</strong>
                <br />
                {contact.phone.split("\n").map((phone, i) => (
                  <a
                    key={i}
                    href={`tel:${phone.trim()}`}
                    className="text-blue-600 hover:text-blue-800 block"
                  >
                    {phone.trim()}
                  </a>
                ))}
              </p>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default ContactUsCard;
